module.exports = __webpack_public_path__ + "static/media/close.a2064977.svg";